import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Input, InputAdornment, IconButton } from '@material-ui/core';
import classNames from 'classnames';
import PropTypes, { node } from 'prop-types'
import Typo from './CustomTypo'
import { getCardType } from '../utils/util';
import { VisaIcon, DefaultCard, MasterIcon, VisaCardIcon, MasterCardIcon, AmexIcon, DinnerIcon, DiscoverIcon, JCBIcon, UnionPayIcon } from './icons';

// import {withNamespaces} from 'react-i18next';

const styles = theme => ({
    customPadding: {
        paddingTop: 0,
        paddingBottom: 0,
        height: 26
    },
    inputLine: {
        width: '100%',
        borderBottomColor: theme.palette.primary.main,
    },
    iconStyle: {
        // width: theme.icons.large.width,
        // height: theme.icons.medium.height,
        // marginBottom: theme.spacing()
    },
    defaultIcon: {
        // width: theme.icons.large.width,
        // height: theme.icons.medium.height
    }
});

class Card extends Component {

    render() {
        const { input, meta, label, classes, isHiddenIcon, labelColor, fieldFormat, fieldParse, isEdit, cardType, ...rest } = this.props;
        let { type } = this.props;
        var card = "";
        var inputProps = { ...input };
        let color = labelColor ? labelColor : 'default';
        let cType = cardType ? cardType : getCardType(inputProps.value);
        //console.log(' cType======',cType)
        let CardIcon = DefaultCard;
        if (cType) {
            if (cType === 'Visa')//4
                CardIcon = VisaCardIcon;
            else if (cType === 'Mastercard')//2
                CardIcon = MasterCardIcon;
            else if(cType==='American Express'){//3
                CardIcon = AmexIcon;
            }else if(cType==='Diners Club'){//36
                CardIcon = DinnerIcon;
            }else if(cType==='Discover'){//6
                CardIcon = DiscoverIcon;
            }else if(cType==='JCB'){//1
                CardIcon = JCBIcon;
            }else if(cType==='UnionPay'){//8
                CardIcon = UnionPayIcon;
            }
        }
        if (!type) {
            type = 'text';
        }
        return (
            <div>
                {label && <Typo type="inputTitle" color={color} >{label}</Typo>}
                <Input
                    {...rest}
                    {...input}
                    disabled={!isEdit}
                    name={inputProps.name}
                    className={classNames(classes.inputLine, classes.customPadding)}
                    type={type}
                    fullWidth
                    onChange={(e) => { fieldParse ? inputProps.onChange(fieldParse(e.target.value)) : inputProps.onChange(e) }}
                    onBlur={(e) => { if (fieldFormat && (rest.fieldFormatOnBlur == true)) { inputProps.onChange(fieldFormat(inputProps.value)) } }}
                    value={(fieldFormat && !rest.fieldFormatOnBlur) ? fieldFormat(inputProps.value) : inputProps.value}
                    endAdornment={
                        <InputAdornment position="end">
                            <CardIcon className={classes.iconStyle} />
                        </InputAdornment>
                    }
                />
                {meta.error && meta.touched && <Typo type="warning" color='error' >{meta.error}</Typo>}
            </div>
        )
    }
}
Card.propTypes = {
    cardType: PropTypes.oneOf([
        'visa',
        'union',
        'master',
        'cvv',
    ]),
    type: PropTypes.oneOf([
        'text',
        'password',
    ]),
}

export default withStyles(styles)(Card);